export default {
  direcciones: [],
  direccionSeleccionada: {
    AvisoEmailDestino :false,
    AvisoEmailRemitente :false,
    AvisoSmsDestino :false,
    AvisoSmsRemitente :false,
    Codigo :"",
    CodigoCliente :"",
    CodigoPostal :"",
    Corporativo :"",
    DepartamentoCliente :"",
    Direccion :"",
    Email :"",
    Id :null,
    IdCliente :null,
    IdDomicilio :null,
    IdPais :null,
    IdPoblacion :null,
    Latitud :0,
    Longitud :0,
    Marca :"",
    MasDatos :"",
    Movil :"",
    Nombre :"",
    Nombre2 :"",
    NumeroDireccion :0,
    Observacion :"",
    PisoDireccion :"",
    Poblacion :"",
    Pointer :"",
    Referencia :"",
    Telefono :"",
    TipoDireccion :"c/",
    Pais:"España",
    Nif:0
  },
  filtro: {
    Codigo: '',
    Nombre: '',
    Nif: '',
    Direccion: ''
  },
  error: false,
  errorMessage: ''
}
